import * as React from 'react';
import svg from './pdf.svg';

function PdfXlsx() {
  return <img src={svg} alt="Pdf" />;
}

export default PdfXlsx;
